<template>
  <div id="appHome">
    <div class="splash">
      <img class="splashImg" src="~assets/img/home/splash.png" />
    </div>

    <van-dialog v-model="showPrivacy" :title="$t.privacy.title" @confirm="agree" :confirm-button-text="$t.meta.agree"
      @cancel="exitApp" :cancel-button-text="$t.meta.disagree" show-confirm-button
      :show-cancel-button="env ? true : false" theme="round-button">
      <slot name="default">
        <div class="privacy-alert">
          <div class="text1">{{ $t.privacy.text1 }}</div>
          <div class="text2">
            {{ $t.privacy.text2 }}
            <b @click="gotoTerm">
              <u>{{ $t.privacy.text3 }}</u>
            </b>
          </div>
          <div class="end">{{ $t.privacy.end }}</div>
        </div>
      </slot>
    </van-dialog>
  </div>
</template>
<script>
import { isAPP } from "@/plugins/environment/type.js";

export default {
  name: "AppHome",
  data() {
    return {
      showPrivacy: false,
      env: isAPP(), // 当前环境
      isLogin: false,
      nextRoute: "home",
    };
  },
  beforeMount() {
    let auth = JSON.parse(localStorage.getItem("auth")); //判断是否登录
    if (auth) {
      if (auth.token) {
        this.isLogin = true;
      } else {
        this.isLogin = false;
      }

      if (auth.IsShopSubmit == 1 && auth.IsShopCheck == 1) {
        this.nextRoute = "home"; //已认证
      } else {
        this.nextRoute = "user/userManage"; //未认证
      }
    }

    let isPrivacy = JSON.parse(localStorage.getItem("isPrivacy")); //隐私政策
    if (!isPrivacy) {
      this.showPrivacy = true;
    } else {
      this.initPlugins();
      this.next();
    }
  },
  methods: {
    initPlugins() {
      this.$commonEnv.commonAction(this.$commonEnv.actionType.initJpush); //极光推送
      this.$commonEnv.commonAction(this.$commonEnv.actionType.initApprate); //App评分
    },
    next() {
      this.$commonEnv.commonAction(this.$commonEnv.actionType.routerPush, {
        isParams: false,
        path: this.isLogin ? this.nextRoute : "auth/login",
        name: "",
        query: [],
      });
    },
    exitApp() {
      this.$commonEnv.commonAction(this.$commonEnv.actionType.exitapp);
    },
    gotoTerm() {
      this.$commonEnv.commonAction(this.$commonEnv.actionType.routerPush, {
        isParams: false,
        path: "terms",
        name: "Terms",
        query: [],
      });
    },
    agree() {
      localStorage.setItem("isPrivacy", true);
      this.initPlugins();
      this.next();
    },
  },
};
</script>

<style lang="scss" scoped>
.privacy-alert {
  padding: 5%;
  font-size: 14px;
  line-height: 2;
}

.splash {
  .splashImg {
    position: absolute;
    top: 0;
    left: 0;
    z-index: 999;
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
}
</style>